import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import SubmissionReview from '../components/review/SubmissionReview';

const ReviewSubmissionPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthStatus();
  }, []);

  async function checkAuthStatus() {
    try {
      await Auth.currentAuthenticatedUser();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Container className="my-4">
        <Row>
          <Col>
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return (
      <Container className="my-4">
        <Row>
          <Col>
            <Alert variant="warning">
              <Alert.Heading>Authentication Required</Alert.Heading>
              <p>
                You need to be logged in to access the review area. Please go to the{' '}
                <Alert.Link onClick={() => navigate('/user')}>
                  user page
                </Alert.Link>{' '}
                to sign in or register.
              </p>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return <SubmissionReview />;
};

export default ReviewSubmissionPage;
